import { setAuth, type AxiosInstance } from '@mint-lib/api';
import { BaseAuthAdminService } from '@mint-lib/auth';

import type { MintAdminServiceLocatorAbstractFactoryContext } from '../types.js';
import { adminBaseStorage } from './auth/adminBaseStorage.js';

export const getAuth0Credentials = async (guestApi: AxiosInstance) => {
  return guestApi
    .get('/api/authentication/v1/auth0/admin/credentials/')
    .then((data) => {
      return data.data;
    });
};

export async function authFactory(
  ctx: MintAdminServiceLocatorAbstractFactoryContext,
): Promise<BaseAuthAdminService> {
  const guestApi = await ctx.getOrThrow('http', 'guestApi');
  const auth0Credentials = await getAuth0Credentials(guestApi);

  const auth = new BaseAuthAdminService(
    guestApi,
    adminBaseStorage,
    auth0Credentials,
  );

  // @ts-ignore remove this line after migration to new api
  setAuth(auth);
  ctx.addEffect(
    auth.getEventEmitter().addChannel('auth', 'auth', ctx.eventBus),
  );
  ctx.addEffect(
    auth.getEventEmitter().addChannel('auth', 'logout', ctx.eventBus),
  );
  return auth;
}
